module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var columns = widget.gridColumns() 
    ; __append("\n")
    ;  var actions = widget.gridActions() 
    ; __append("\n<div class=\"gridview table wh100\">\n\n    ")
    ;  if (widget.showHeader) { 
    ; __append("\n    <div>\n        <div class=\"gridview__header\">\n            <table class=\"gridview__table\" name=\"gridview-header\">\n                <colgroup>\n                    ")
    ;  Util.each(columns, function (column) { 
    ; __append("\n                    <col width=\"")
    ; __append(escapeFn( column.width ? column.width : "*" ))
    ; __append("\">\n                    ")
    ;  }) 
    ; __append("\n\n                    ")
    ;  Util.each(actions, function (action) { 
    ; __append("\n                    <col width=\"")
    ; __append(escapeFn( action.width ? action.width : "*" ))
    ; __append("\">\n                    ")
    ;  }) 
    ; __append("\n                </colgroup>\n                <tbody>\n                <tr>\n                    ")
    ;  Util.each(columns, function (column) { 
    ; __append("\n                    <td data-is-sorted=\"")
    ; __append(escapeFn( column.sorted ))
    ; __append("\">\n                        ")
    ; __append(escapeFn( column.title ))
    ; __append("\n                    </td>\n                    ")
    ;  }) 
    ; __append("\n                    ")
    ;  Util.each(actions, function (action) { 
    ; __append("\n                    <td>\n                    </td>\n                    ")
    ;  }) 
    ; __append("\n                </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n    ")
    ;  } 
    ; __append("\n\n    <div>\n        <div class=\"gridview__body\">\n            <div>\n                <div>\n                    <table class=\"gridview__table\" name=\"gridview-body\">\n                        <colgroup>\n                            ")
    ;  Util.each(columns, function (column) { 
    ; __append("\n                            <col width=\"")
    ; __append(escapeFn( column.width ? column.width : "*" ))
    ; __append("\">\n                            ")
    ;  }) 
    ; __append("\n\n                            ")
    ;  Util.each(actions, function (action) { 
    ; __append("\n                            <col width=\"")
    ; __append(escapeFn( action.width ? action.width : "*" ))
    ; __append("\">\n                            ")
    ;  }) 
    ; __append("\n                        </colgroup>\n                        <tbody name=\"list-items\">\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    ")
    ;  if (widget.showFooter) { 
    ; __append("\n    <div>\n        <div class=\"gridview__footer split cell__middle\" name=\"gridview-footer\">\n            <div class=\"split__left\">\n                ")
    ; 
                    var createEnabled = Util.isFunction(widget.createEnabled)
                        ? !!widget.createEnabled()
                        : !!widget.createEnabled;
                
    ; __append("\n\n                ")
    ;  if (createEnabled) { 
    ; __append("\n                <div class=\"gridview__footer_button\" title=\"Создать\" on-click=\"onItemCreateClick\">+ Добавить</div>\n                ")
    ;  } 
    ; __append("\n            </div>\n            <div class=\"split__right\">\n                <div class=\"count\">\n                    Записей: <span name=\"gridview-count\">")
    ; __append(escapeFn( widget.gridCount ))
    ; __append("</span>\n                </div>\n                <div>\n                    <select title=\"Выбрать страницу\" name=\"gridview-pages\" on-change=\"onPageChange\">\n                    </select>\n                </div>\n                <div class=\"gridview__footer_icon icon-arrow-right\" title=\"Следующая страница\" on-click=\"onNextPageClick\"></div>\n                <div class=\"gridview__footer_icon icon-arrow-left\" title=\"Предыдущая страница\" on-click=\"onPrevPageClick\"></div>\n                <div class=\"gridview__footer_icon icon-loop2\" title=\"Обновить страницу\" on-click=\"onRefreshPageClick\"></div>\n            </div>\n        </div>\n    </div>\n    ")
    ;  } 
    ; __append("\n\n</div>\n")
  }
  return __output.join("");

}